$('.rb-radio').click(function(e){
    if(e.target.tagName !== 'INPUT') {
        $(e.currentTarget).closest('.rb-radio').find('input').trigger('click');
    }
});

$('.rb-action-select').click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    var $el = $(e.currentTarget);
    $el.trigger('radio-button-click', [$el.attr('name'), $el.val()]);
    return false;
});
